import { useQuery } from 'react-query';
import { getSortFn } from '@fortress-technology-solutions/fortress-component-library/utils/index';
import RentableItemsService from '../../../services/rentableItemsService';
import ResidentPetService from '../../../services/residentPetService';

const rentableItemsService = new RentableItemsService();
const residentPetService = new ResidentPetService();

export const useFetchHouseholdPets = ({
  organizationId,
  propertyId,
  householdId,
  enabled,
}) => {
  const { data = [], dataUpdatedAt } = useQuery(
    ['getHouseholdPets', propertyId, householdId],
    () =>
      residentPetService.getResidentPetsForHousehold(
        organizationId,
        propertyId,
        householdId,
      ),
    {
      enabled: Boolean(enabled && organizationId && propertyId && householdId),
      refetchOnWindowFocus: false,
    },
  );

  const nonServicePets = data.filter(
    (pet) => !pet?.residentPet?.isServiceAnimal,
  );

  return {
    petCount: nonServicePets.length,
    householdPetsUpdatedAt: dataUpdatedAt,
  };
};

export const useFetchAllHouseholdRentableItems = ({
  organizationId,
  propertyId,
  householdId,
  enabled,
}) => {
  const { data = [], dataUpdatedAt } = useQuery(
    ['getAllHouseholdRentableItems', propertyId, householdId],
    () =>
      rentableItemsService.getAllHouseholdRentableItems(
        organizationId,
        propertyId,
        householdId,
      ),
    {
      enabled: Boolean(enabled && organizationId && propertyId && householdId),
      select: (queryData) =>
        [...(queryData ?? [])].sort(getSortFn('startDate', 'ASC').date),
      refetchOnWindowFocus: false,
    },
  );

  return {
    householdRentableItems: data,
    householdRentableItemsUpdatedAt: dataUpdatedAt,
  };
};
